import React, {useEffect, useState} from 'react';
import {
    Container,
    Button,
    Menu,
    FormField,
    Select,
    Form,
    Checkbox,
    TextArea,
    Icon,
    Input,
    Message,
    Header,
    Grid,
    GridColumn,
    Dimmer,
    Loader,
    Dropdown,
    MenuItem,
    Sidebar,
    Segment,
    Accordion,
    List,
} from 'semantic-ui-react'

import {useSelector, useDispatch} from "react-redux";
import withRouter from "../common/withRouter";
import * as Yup from "yup";
import {useFormik} from "formik";
import PlacesAutocomplete from "../common/PlacesAutocomplete";
import {InputMask, Mask, generatePattern} from '@react-input/mask';

import {
    deviceRegister,
} from '../slices/register'
import {
    deviceAdaptStart,
    deviceAdaptUpdate,
    getLanguage
} from '../slices/adapt'
import {Link} from "react-router-dom";

const getDevice = () => {
    let unknown = '-';

    // browser
    let nVer = navigator.appVersion;
    let nAgt = navigator.userAgent;
    let browser = navigator.appName;
    let version = '' + parseFloat(nVer);
    let nameOffset, verOffset, ix;

    // Yandex Browser
    if ((verOffset = nAgt.indexOf('YaBrowser')) !== -1) {
        browser = 'Yandex';
        version = nAgt.substring(verOffset + 10);
    }
    // Samsung Browser
    else if ((verOffset = nAgt.indexOf('SamsungBrowser')) !== -1) {
        browser = 'Samsung';
        version = nAgt.substring(verOffset + 15);
    }
    // UC Browser
    else if ((verOffset = nAgt.indexOf('UCBrowser')) !== -1) {
        browser = 'UC Browser';
        version = nAgt.substring(verOffset + 10);
    }
    // Opera Next
    else if ((verOffset = nAgt.indexOf('OPR')) !== -1) {
        browser = 'Opera';
        version = nAgt.substring(verOffset + 4);
    }
    // Opera
    else if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
        browser = 'Opera';
        version = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf('Version')) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    }
    // Legacy Edge
    else if ((verOffset = nAgt.indexOf('Edge')) !== -1) {
        browser = 'Microsoft Legacy Edge';
        version = nAgt.substring(verOffset + 5);
    }
    // Edge (Chromium)
    else if ((verOffset = nAgt.indexOf('Edg')) !== -1) {
        browser = 'Microsoft Edge';
        version = nAgt.substring(verOffset + 4);
    }
    // MSIE
    else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
        browser = 'Microsoft Internet Explorer';
        version = nAgt.substring(verOffset + 5);
    }
    // Chrome
    else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
        browser = 'Chrome';
        version = nAgt.substring(verOffset + 7);
    }
    // Safari
    else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
        browser = 'Safari';
        version = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf('Version')) !== -1) {
            version = nAgt.substring(verOffset + 8);
        }
    }
    // Firefox
    else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
        browser = 'Firefox';
        version = nAgt.substring(verOffset + 8);
    }
    // MSIE 11+
    else if (nAgt.indexOf('Trident/') !== -1) {
        browser = 'Microsoft Internet Explorer';
        version = nAgt.substring(nAgt.indexOf('rv:') + 3);
    }
    // Other browsers
    else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
        browser = nAgt.substring(nameOffset, verOffset);
        version = nAgt.substring(verOffset + 1);
        if (browser.toLowerCase() === browser.toUpperCase()) {
            browser = navigator.appName;
        }
    }
    // trim the version string
    if ((ix = version.indexOf(';')) !== -1) version = version.substring(0, ix);
    if ((ix = version.indexOf(' ')) !== -1) version = version.substring(0, ix);
    if ((ix = version.indexOf(')')) !== -1) version = version.substring(0, ix);

    let majorVersion = parseInt('' + version, 10);
    if (isNaN(majorVersion)) {
        version = '' + parseFloat(nVer);
        majorVersion = parseInt(nVer, 10);
    }

    // mobile version
    let mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);

    // cookie
    let cookieEnabled = (navigator.cookieEnabled) ? true : false;

    if (typeof navigator.cookieEnabled == 'undefined' && !cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = (document.cookie.indexOf('testcookie') !== -1) ? true : false;
    }

    // system
    let os = unknown;
    let clientStrings = [
        {s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/},
        {s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/},
        {s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/},
        {s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/},
        {s: 'Windows Vista', r: /Windows NT 6.0/},
        {s: 'Windows Server 2003', r: /Windows NT 5.2/},
        {s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/},
        {s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/},
        {s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/},
        {s: 'Windows 98', r: /(Windows 98|Win98)/},
        {s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/},
        {s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
        {s: 'Windows CE', r: /Windows CE/},
        {s: 'Windows 3.11', r: /Win16/},
        {s: 'Android', r: /Android/},
        {s: 'Open BSD', r: /OpenBSD/},
        {s: 'Sun OS', r: /SunOS/},
        {s: 'Chrome OS', r: /CrOS/},
        {s: 'Linux', r: /(Linux|X11(?!.*CrOS))/},
        {s: 'iOS', r: /(iPhone|iPad|iPod)/},
        {s: 'Mac OS X', r: /Mac OS X/},
        {s: 'Mac OS', r: /(Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
        {s: 'QNX', r: /QNX/},
        {s: 'UNIX', r: /UNIX/},
        {s: 'BeOS', r: /BeOS/},
        {s: 'OS/2', r: /OS\/2/},
        {s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
    ];
    for (let id in clientStrings) {
        let cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
            os = cs.s;
            break;
        }
    }

    let osVersion = unknown;
    let type = 'web'
    if (/Windows/.test(os)) {
        osVersion = /Windows (.*)/.exec(os)[1];
        os = 'Windows';
        type = 'windows'
    }

    switch (os) {
        case 'Mac OS':
        case 'Mac OS X':
            osVersion = /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([\.\_\d]+)/.exec(nAgt)[1];
            break;
        case 'Android':
            osVersion = /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([\.\_\d]+)/.exec(nAgt)[1];
            type = 'android'
            break;

        case 'iOS':
            type = 'iphone'
            osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
            osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0);
            break;
        default:
            break;
    }
    return {
        browser: browser,
        browserVersion: version,
        browserMajorVersion: majorVersion,
        mobile: mobile,
        os: os,
        osVersion: osVersion,
        cookies: cookieEnabled,
        type
    }
}
const ClinicianForm = (props) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)
    // const [validationError, setValidationError] = useState(false)
    const [translate, setTranslate] = useState('en')
    const [message, setMessage] = useState("")
    const [errorMessage, setErrorMessage] = useState("")
    const [done, setDone] = useState(false)
    const [width, setWidth] = useState(window.innerWidth);
    const [visible, setVisible] = useState(false);
    const [open, setOpen] = useState(false)
    const [activeIndex, setActiveIndex] = useState([0])
    const {data, language} = useSelector((state) => ({
        data: state.adapt.data,
        language: state.adapt.language,
    }));

    const [disabledSelect, setDisabledSelect] = useState(false);
    const userDevice = getDevice()
    useEffect(() => {
        let deviceId = sessionStorage.getItem('device') || undefined
        let adaptId = sessionStorage.getItem('adapt') || undefined
        console.info('Device not found, registering new device.')
        const params = new URLSearchParams(props.router.location.search);
        const translate = params.get("translate")
        setTranslate(translate || "en")
        dispatch(getLanguage())

        if (!deviceId && !adaptId) {
            dispatch(deviceRegister({
                model: "",
                type: userDevice.type,
                os: userDevice.os + " " + userDevice.osVersion
            }, (newDevice) => {
                if (newDevice.id) {
                    deviceId = newDevice.id
                    console.info('new device ID generated', newDevice.id)
                }
                if (deviceId === undefined) throw Error('Device ID busted')
                sessionStorage.setItem('device', deviceId)
                dispatch(deviceAdaptStart({deviceId}, (data) => {
                    sessionStorage.setItem('adapt', data.id)
                }))
            }))
        } else {
            dispatch(deviceAdaptStart({deviceId}, (data) => {
                sessionStorage.setItem('adapt', data.id)
            }))
        }
    }, [dispatch])

    const handleStart = () => {
        let deviceId = sessionStorage.getItem('device') || undefined
        dispatch(deviceAdaptStart({deviceId}, (data) => {
            sessionStorage.setItem('adapt', data.id)
            setDone(false)
            setMessage("")
            setError(false)
            setActiveIndex([0])
            // setValidationError(false)
        }))
    }

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
        setVisible(isMobile ? visible : false)
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    function isMobileDevice() {
        const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        return regex.test(navigator.userAgent);
    }

    const isMobile = width <= 768

    if (isMobileDevice()) {
        // console.log("Mobile device detected");
    } else {
        // console.log("Desktop device detected");
    }
    let i18n = (language && language.data && language.data.languages[translate].value) || {}
    document.title = i18n.page_title || "Resource Form";

    const handlePlaceSelectLanguage = (index) => {
        return (result) => {
            console.log(result)
            let data = {...validation.values?.data}
            let locations = [...data.submission?.locations]
            let newLocation = locations.map((item, ind) => {
                let newItem = {...item}
                if (ind === index) {
                    newItem.location_address = result && result.label
                }
                return newItem
            })
            data = {
                ...validation.values.data,
                submission: {
                    ...data.submission,
                    locations: newLocation
                }
            }
            console.log(data)
            validation.setFieldValue("data", data)
        }
    }
    const handlePlaceSelectLanguage2 = (index) => {
        return (result) => {
            setDisabledSelect(true)
            let data = {...validation.values?.data}
            let locations = [...data.submission?.locations]
            let newLocation = locations.map((item, ind) => {
                let newItem = {...item}
                if (ind === index) {
                    newItem.location_address = result && result.description
                }
                return newItem
            })
            data = {
                ...validation.values.data,
                submission: {
                    ...data.submission,
                    locations: newLocation
                }
            }
            validation.setFieldValue("data", data)
        }
    }
    const handlePlaceChangeLanguage2 = (index) => {
        return (text) => {
            let data = {...validation.values?.data}
            let locations = [...data.submission?.locations]
            let newLocation = locations.map((item, ind) => {
                let newItem = {...item}
                if (ind === index) {
                    newItem.location_address = text
                }
                return newItem
            })
            data = {
                ...validation.values.data,
                submission: {
                    ...data.submission,
                    locations: newLocation
                }
            }
            validation.setFieldValue("data", data)
            setDisabledSelect(false)
        }
    }
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {...data},
        validationSchema: Yup.object().shape({}),
        onSubmit: (values) => {
            setLoading(true)

            let insurances_accepted = values.data.submission.insurance.insurances_accepted
            let found = insurances_accepted.find(accepted => {
                let others = accepted.name === "Other" && accepted.selected
                return others
            })
            let specified = insurances_accepted.find(accepted => {
                return accepted.specified
            })
            if (found) {
                if (!specified) {
                    insurances_accepted.push({
                        name: found.specify,
                        selected: true,
                        specified: true
                    })
                } else {
                    insurances_accepted = insurances_accepted.map(item => {
                        let newItem = {...item}
                        if (newItem.specified === true) {
                            newItem.name = found.specify
                            newItem.selected = true
                        }
                        return newItem
                    })
                }
            }
            const option = {
                mask: '(___) ___-____',
                replacement: {_: /\d/},
            }
            const mask = new Mask(option);
            const pattern = generatePattern('full-inexact', option);
            const isValid = RegExp(pattern).test(values.data.submission.contact_info.organization_contact_phone);
            let newData = {
                ...values,
                data: {
                    ...values.data,
                    submission: {
                        ...values.data.submission,
                        contact_info: {
                            ...values.data.submission.contact_info,
                            organization_contact_phone: isValid ? mask.unformat(values.data.submission.contact_info.organization_contact_phone) : null
                        },
                        locations: values.data.submission.locations.map(location => {
                            let editLocation = {...location}
                            let others = editLocation.services_offered.find(offered => offered.name === "Other" && offered.selected)
                            let specifiedLoc = editLocation.services_offered.find(offered => offered.specified)

                            const isValidLoc = RegExp(pattern).test(editLocation.location_phone);
                            editLocation.location_phone = isValidLoc ? mask.unformat(editLocation.location_phone) : null
                            if (others) {
                                if (!specifiedLoc) {
                                    editLocation.services_offered.push({
                                        name: others.specify,
                                        selected: true,
                                        specified: true
                                    })
                                } else {
                                    editLocation.services_offered = editLocation.services_offered.map(item => {
                                        let newItem = {...item}
                                        if (newItem.specified === true) {
                                            newItem.name = others.specify
                                            newItem.selected = true
                                        }
                                        return newItem
                                    })
                                }
                            }
                            return editLocation
                        }),
                        insurance: {
                            ...values.data.submission.insurance,
                            insurances_accepted
                        }
                    }
                },
                name: values.data.submission.contact_info.organization_name
            }

            dispatch(deviceAdaptUpdate(newData, (data) => {
                if (data?.error?.show) {
                    let errorIndex = [...new Set(data?.error?.errors?.filter(err => err.property.indexOf('locations') != -1)?.map(props => parseInt(props.property.replace(/\D/g, ''))))]
                    setActiveIndex(errorIndex)
                    setError(data.error)
                    if (data.error.errors && data.error.errors?.length > 0) {
                        // let validationError = {}
                        // data.error.errors?.forEach(error => {
                        //     validationError[error.property] = error.message
                        // })
                        // setValidationError(validationError)
                    }
                    window.scrollTo({top: 0, behavior: "smooth"})
                    setLoading(false)
                } else {
                    setMessage(data.message)
                    setErrorMessage(null)
                    setDone(true)
                    setLoading(false)
                    window.scrollTo({top: 0, behavior: "smooth"})
                }
            }))

        }
    });
    const handleClick = (e, titleProps) => {
        const {index} = titleProps
        let currentIndexs = [...activeIndex]
        let found = currentIndexs.indexOf(index)
        if (found > -1) { // only splice array when item is found
            currentIndexs.splice(found, 1); // 2nd parameter means remove one item only
        } else {
            currentIndexs.push(index)
        }
        setActiveIndex(currentIndexs)
    }

    const addCustomServiceOffered = (index, valida) => {
        // console.log("addCustomServiceOffered")
        // let data = {...valida.values?.data}
        // let locations = [...data.submission?.locations]
        // let newLocation = locations.map((item, ind) => {
        //     let newItem = {...item}
        //     if (ind === index) {
        //         let newService = [...newItem.services_offered]
        //         newService.push({
        //             name:"",
        //             selected: true,
        //             custom: true
        //         })
        //         newItem.services_offered = newService
        //     }
        //     return newItem
        // })
        // data = {
        //     submission: {
        //         ...data.submission,
        //         locations: newLocation
        //     }
        // }
        // valida.setFieldValue("data", data)
    }
    const removeCustomServiceOffered = (index, valida) => {
        // console.log("removeCustomServiceOffered")
        // let data = {...valida.values?.data}
        // let locations = [...data.submission?.locations]
        // let newLocation = locations.map((item, ind) => {
        //     let newItem = {...item}
        //     if (ind === index) {
        //         let newService = [...newItem.services_offered]
        //         let foundIndex = newService.filter(item => !item.custom)
        //         console.log( foundIndex)
        //         newItem.services_offered = foundIndex
        //     }
        //     return newItem
        // })
        // data = {
        //     submission: {
        //         ...data.submission,
        //         locations: newLocation
        //     }
        // }
        // valida.setFieldValue("data", data)
    }

    document.title = i18n.become_resource_menu || 'Become a Resource';

    const isError = (field) => {
        let found = error.errors && error.errors.find(err => {
            return err.property === field
        })
        return found !== undefined
    }
    return (
        <React.Fragment>
            <Menu fixed='top' inverted
                  style={{background: "linear-gradient(90deg, rgba(11,89,223,1) 0%, rgba(24,122,229,1) 49%, rgba(68,225,249,1) 100%)"}}>
            </Menu>
            <Container style={{marginTop: 40, alignContent: "center"}}>
                <Grid doubling columns={2}
                      style={{alignContent: "right", marginTop: 0}}>

                    <GridColumn floated='right' width={8} style={{
                        padding: 0,
                        alignContent: "center",
                        textAlign: isMobile ? "center" : "right",
                    }}>

                        <Button
                            aria-label={i18n.clinician_form_button}
                            className={'menu_button'}
                            icon
                            labelPosition='left'
                            onClick={() => {
                                window.open(window.CONFIG.clinicianURL + "?translate=" + translate, "_self")
                            }}>
                            <Icon name='list alternate' size={"large"}/>
                            {i18n.clinician_form_button}</Button>
                        <Button.Group className={"language"}
                        >
                            <Button
                                aria-label={"Select Language"}
                                icon
                                labelPosition='left'
                                className={'language_button_active'}
                                onBlur={() => setTimeout(() => {
                                    setOpen(false)
                                }, 200)}
                                onClick={() => setOpen(!open)}>
                                <Icon name='world' size={"large"}/>
                                {translate === "en" ? "English" : 'Español'}</Button>
                            <Dropdown
                                open={open}
                                style={{marginLeft: 1}}
                                aria-label={"Select Language"}
                                className='button icon'
                                onBlur={() => setOpen(false)}
                                onClick={() => setOpen(!open)}
                            ><Dropdown.Menu>
                                {translate === "es" &&
                                    <Dropdown.Item
                                        aria-label={"Inglés"}
                                        as={Button}
                                        className={translate === "en" ? 'language_button_active' : "language_button"}
                                        onClick={() => {
                                            setTranslate("en")
                                        }}>Inglés
                                    </Dropdown.Item>
                                }
                                {translate === "en" &&
                                    <Dropdown.Item
                                        aria-label={"Spanish"}
                                        as={Button}
                                        className={translate === "es" ? 'language_button_active' : "language_button"}
                                        onClick={() => {
                                            setTranslate("es")
                                        }}>Spanish
                                    </Dropdown.Item>
                                }
                            </Dropdown.Menu>
                            </Dropdown>
                        </Button.Group>
                    </GridColumn>
                </Grid>
            </Container>
            <Container style={{marginTop: 20, alignContent: "center"}}>
                <Grid columns={2}
                      style={{padding: 20, alignContent: "center"}}>
                    <GridColumn width={1} style={{
                        padding: 0,
                        paddingTop: 15,
                        textAlign: isMobile ? "center" : "initial"
                    }}>
                        <Link to={"/?translate=" + translate}>
                            <Header as={'h4'} style={{cursor: "pointer"}}>
                                <span style={{color: "#0959DF"}}>ADAPT4</span>Change
                            </Header>
                        </Link>
                    </GridColumn>
                    <GridColumn floated='right'
                                width={isMobile ? 1 : 11} style={{
                        padding: 0,
                        paddingTop: 5,
                        alignContent: "center",
                        textAlign: isMobile ? "center" : "right",
                    }}>

                        {isMobile ? <>

                            <Icon name={visible ? "times" : "bars"}
                                  size='large'
                                  checked={visible}
                                  onClick={() => setVisible(!visible)}/>

                        </> : null}
                        {isMobile ? null :
                            <Menu secondary floated='right'>
                                <Link to={"/resources?translate=" + translate}>
                                    <MenuItem
                                        content={i18n.resource_menu || "Resources"}
                                    />
                                </Link>
                                <Link to={"/about?translate=" + translate}>
                                    <MenuItem
                                        content={i18n.about_us_menu || 'About Us'}
                                    />
                                </Link>
                                <Link to={"/becomearesource?translate=" + translate}>
                                    <MenuItem
                                        content={i18n.become_resource_menu || 'Become a Resource'}
                                    />
                                </Link>
                            </Menu>}

                    </GridColumn>
                </Grid>
            </Container>
            <Sidebar.Pushable style={{border: "none"}}>
                <Sidebar
                    inverted
                    as={Menu}
                    animation='overlay'
                    direction='top'
                    vertical
                    onHide={() => setVisible(false)}
                    visible={visible}
                >
                    <Link to={"/resources?translate=" + translate}>
                        <MenuItem
                            content={i18n.resource_menu || "Resources"}
                        />
                    </Link>
                    <Link to={"/about?translate=" + translate}>
                        <MenuItem
                            content={i18n.about_us_menu || 'About Us'}
                        />
                    </Link>
                    <Link to={"/becomearesource?translate=" + translate}>
                        <MenuItem
                            content={i18n.become_resource_menu || 'Become a Resource'}
                        />
                    </Link>
                </Sidebar>
                <Sidebar.Pusher dimmed={visible}>
                    <Menu inverted
                          style={{backgroundColor: "#1E3766", paddingBottom: 50, paddingTop: 50}}>
                        <Container style={{display: "flex", flexDirection: "column"}}>
                            <div style={{display: "flex", flexDirection: "row", marginBottom: 0}}>

                            </div>
                            <Header as={'h4'} style={{
                                textAlign: "center",
                                color: "white",
                                letterSpacing: 2.5,
                                fontFamily: "Rockwell",
                                fontWeight: 400,
                                fontSize: isMobile ? 28 : 40
                            }}>
                                {i18n.become?.header}
                            </Header>
                        </Container>
                    </Menu>

                    {loading &&
                        <Dimmer active inverted>
                            <Loader inverted>Loading</Loader>
                        </Dimmer>
                    }
                    <Container style={{marginTop: '2em'}}>
                        {/*<Button className={'how_to_button'}*/}
                        {/*        floated="right"*/}
                        {/*        color={'blue'}*/}
                        {/*        onClick={() => {*/}
                        {/*            props.router.navigate('/howto')*/}
                        {/*        }}>How to use OUD Custom Discharge</Button>*/}
                        {/*<br/>*/}
                        {/*<br/>*/}
                        {/*<br/>*/}
                        <p style={{textAlign: "center", marginTop: 75}}>
                            {i18n.become?.sub_header}
                        </p>
                        <Container id="clinicianPage" text style={{
                            marginTop: '1em',
                            paddingBottom: "15em",
                        }}>


                            <Form onSubmit={async (e) => {
                                e.preventDefault();
                                // const validationErrors = await validation.validateForm()
                                // if (Object.keys(validationErrors).length > 0) {
                                //     // validation.setTouched(setNestedObjectValues(validationErrors, true));
                                //     // return;
                                // }
                                // if (checkSubmission(validation.values.data.submission)) {
                                //     validation.handleSubmit();
                                // } else {
                                //     setErrorMessage("Please provide the required fields")
                                //     setMessage(null)
                                //     setLoading(false)
                                //     window.scrollTo({top: 0, behavior: "smooth"})
                                // }
                                validation.handleSubmit();

                                console.log(validation)
                                return false;
                            }}
                                  action="#">
                                {message && <p style={{textAlign: "center", marginTop: 75}}>
                                    {message}
                                </p>}
                                {errorMessage &&
                                    <p style={{textAlign: "center", marginTop: 75, color: "#bd0101"}}>
                                        {errorMessage}
                                    </p>
                                }
                                {!done &&
                                    <div>
                                        <p style={{paddingBottom: 10}}
                                           dangerouslySetInnerHTML={{__html: i18n.page_header_text}}></p>
                                        {error && (error.errors ?
                                            <>
                                                <Message negative
                                                         header={error.message}
                                                         content={
                                                             <List bulleted>
                                                                 {
                                                                     error.errors.map((e,order) => {
                                                                         return <List.Item  key={order}>{e.message}</List.Item>
                                                                     })
                                                                 }
                                                             </List>

                                                         }/>
                                            </> : <Message negative
                                                           header={"Error"}
                                                           content={error.message}/>)}

                                        <h5 className={"text_header"}>
                                            <div className={"numbered_header"}>1
                                            </div>
                                            {i18n.become?.contact_information}
                                        </h5>
                                        <div>
                                            <FormField
                                                control={Input}
                                                placeholder={"Organization Name"}
                                                label={
                                                    <label> {i18n.become?.name_organization}<span
                                                        className={"pull-right"}>
                                                &nbsp;
                                                        *{i18n.become?.required_text}</span></label>
                                                }
                                                onChange={(e, target) => {
                                                    let data = {...validation.values?.data}
                                                    data = {
                                                        ...validation.values.data,
                                                        submission: {
                                                            ...data.submission,
                                                            contact_info: {
                                                                ...data.submission.contact_info,
                                                                organization_name: e.target.value
                                                            }
                                                        }
                                                    }
                                                    validation.setFieldValue("data", data)
                                                }}
                                                value={validation.values?.data?.submission.contact_info.organization_name}
                                                error={isError("contact_info.organization_name")}/>

                                            <FormField
                                                placeholder={"www.example.com"}
                                                control={Input}
                                                label={
                                                    <label> {i18n.become?.website}<span
                                                        className={"pull-right"}>
                                                &nbsp;
                                                        *{i18n.become?.required_text}</span></label>
                                                }
                                                onChange={(e, target) => {
                                                    let data = {...validation.values?.data}
                                                    data = {
                                                        ...validation.values.data,
                                                        submission: {
                                                            ...data.submission,
                                                            contact_info: {
                                                                ...data.submission.contact_info,
                                                                website: e.target.value
                                                            }
                                                        }
                                                    }
                                                    validation.setFieldValue("data", data)
                                                }}
                                                value={validation.values?.data?.submission.contact_info.website}
                                                error={isError("contact_info.website")}
                                            />

                                            <FormField
                                                placeholder={"Full Name"}
                                                control={Input}
                                                label={<>
                                                    <label> {i18n.become?.organization_contact}<span
                                                        className={"pull-right"}>
                                                &nbsp;
                                                        *{i18n.become?.required_text}</span></label>

                                                    <span
                                                        className={"text-muted"}> {i18n.become?.organization_contact_sub}</span>
                                                </>
                                                }
                                                onChange={(e, target) => {
                                                    let data = {...validation.values?.data}
                                                    data = {
                                                        ...validation.values.data,
                                                        submission: {
                                                            ...data.submission,
                                                            contact_info: {
                                                                ...data.submission.contact_info,
                                                                organization_contact: e.target.value
                                                            }
                                                        }
                                                    }
                                                    validation.setFieldValue("data", data)
                                                }}
                                                value={validation.values?.data?.submission.contact_info.organization_contact}
                                                error={isError("contact_info.organization_contact")}
                                            />

                                            <FormField error={isError("contact_info.organization_contact_phone")}>
                                                <label>  {i18n.become?.contact_phone_number || "Contact Phone Number"}<span
                                                    className={"pull-right"}>&nbsp;
                                                    *{i18n.become?.required_text}</span></label>
                                                <span
                                                    className={"text-muted"}> {i18n.become?.phone_number_information || "Phone number of the Organization Contact. This information is for internal use only, and will not be listed publicly."}</span>
                                                <InputMask
                                                    inputMode="numeric"
                                                    placeholder={"e.g. 555-555-5555"}
                                                    aria-label={"Phone Number"}
                                                    mask="(___) ___-____"
                                                    replacement={{_: /\d/}}
                                                    onChange={event => {
                                                        console.log(event)
                                                        let data = {...validation.values?.data}
                                                        data = {
                                                            ...validation.values.data,
                                                            submission: {
                                                                ...data.submission,
                                                                contact_info: {
                                                                    ...data.submission.contact_info,
                                                                    organization_contact_phone: event.target.value
                                                                }
                                                            }
                                                        }
                                                        console.log(data)
                                                        validation.setFieldValue("data", data)
                                                    }}
                                                    value={validation.values?.data?.submission.contact_info.organization_contact_phone}
                                                    error={isError("contact_info.organization_contact_phone")}
                                                />
                                                {/*<Cleave*/}
                                                {/*    aria-label={"Phone Number"}*/}
                                                {/*    name="phone"*/}
                                                {/*    placeholder="xxx xxx xxxx"*/}
                                                {/*    options={{*/}
                                                {/*        phone: true,*/}
                                                {/*        phoneRegionCode: "US",*/}
                                                {/*        numericOnly: true*/}
                                                {/*    }}*/}
                                                {/*    inputmode="numeric"*/}
                                                {/*    onChange={event => {*/}
                                                {/*        let data = {...validation.values?.data}*/}
                                                {/*        data = {*/}
                                                {/*            ...validation.values.data,*/}
                                                {/*            submission: {*/}
                                                {/*                ...data.submission,*/}
                                                {/*                contact_info: {*/}
                                                {/*                    ...data.submission.contact_info,*/}
                                                {/*                    organization_contact_phone: event.target.rawValue*/}
                                                {/*                }*/}
                                                {/*            }*/}
                                                {/*        }*/}
                                                {/*        validation.setFieldValue("data", data)*/}
                                                {/*    }}*/}
                                                {/*    value={validation.values?.data?.submission.contact_info.organization_contact_phone}*/}
                                                {/*    error={isError("contact_info.organization_contact_phone")}*/}
                                                {/*/>*/}
                                            </FormField>

                                            <FormField
                                                placeholder={"name@email.com"}
                                                control={Input}
                                                label={<>
                                                    <label> {i18n.become?.contact_email_address || "Contact Email address"}<span
                                                        className={"pull-right"}>
                                                &nbsp;
                                                        *{i18n.become?.required_text}</span></label>

                                                    <span
                                                        className={"text-muted"}>{i18n.become?.email_address_information || "Email address of the Organization Contact. This information is for internal use only, and will not be listed publicly. "}</span>
                                                </>
                                                }
                                                onChange={(e, target) => {
                                                    let data = {...validation.values?.data}
                                                    data = {
                                                        ...validation.values.data,
                                                        submission: {
                                                            ...data.submission,
                                                            contact_info: {
                                                                ...data.submission.contact_info,
                                                                organization_contact_email: e.target.value
                                                            }
                                                        }
                                                    }
                                                    validation.setFieldValue("data", data)
                                                }}
                                                value={validation.values?.data?.submission.contact_info.organization_contact_email}
                                                error={isError("contact_info.organization_contact_email")}
                                            />
                                        </div>

                                        <h5 className={"text_header"}>
                                            <div className={"numbered_header"}>2
                                            </div>
                                            {i18n.become?.services_information || "Services Information"}
                                        </h5>
                                        <div>
                                            <FormField
                                                style={{width: 50}}
                                                control={Select}
                                                label={
                                                    <label> {i18n.become?.how_many || "How many locations do you offer services at?"}<span
                                                        className={"pull-right"}>
                                                &nbsp;
                                                        *{i18n.become?.required_text}</span></label>
                                                }
                                                options={
                                                    Array.from(Array(10).keys()).map((key, index) => {
                                                        return {key: index, text: key + 1, value: key + 1}
                                                    })
                                                }
                                                onChange={(e, target) => {
                                                    let data = {...validation.values?.data}
                                                    let locations = [...data.submission?.locations]
                                                    let first = locations[0]
                                                    let location_number = target.value

                                                    let currentIndexes = [...activeIndex]
                                                    let found = currentIndexes.indexOf(location_number - 1)
                                                    if (found > -1) { // only splice array when item is found
                                                    } else {
                                                        currentIndexes.push(location_number - 1)
                                                    }
                                                    // setActiveIndex(currentIndexes)

                                                    let new_locations = [...locations]
                                                    console.log(location_number, locations?.length, location_number - locations.length)
                                                    if (location_number < locations?.length)
                                                        new_locations.splice(location_number - locations?.length)
                                                    let newLylocation = {...validation.values?.default.location}
                                                    // Object.keys(first).forEach(key => {
                                                    //     newLylocation[key] = null
                                                    // })
                                                    // newLylocation.services_offered = first.services_offered.map(item => {
                                                    //     return {...item, selected: false}
                                                    // })
                                                    Array.from({length: location_number - locations?.length}, (_, i) => i + 1).forEach((key, index) => {
                                                        new_locations.push(newLylocation)
                                                    })
                                                    data = {
                                                        ...validation.values.data,
                                                        submission: {
                                                            ...data.submission,
                                                            locations: new_locations,
                                                            location_number
                                                        }
                                                    }
                                                    validation.setFieldValue("data", data)
                                                }}
                                                value={validation.values?.data?.submission?.location_number || 1}
                                            />
                                            <Accordion className={"become"}>
                                                {
                                                    validation.values?.data?.submission?.locations.map((loc, index) => {
                                                        return <div  key={index} className={"location_item"}>
                                                            <Accordion.Title
                                                                active={activeIndex.indexOf(index) > -1}
                                                                index={index}
                                                                onClick={handleClick}
                                                            >
                                                                <Icon name='dropdown'/>
                                                                <span className={"text_header_location"}>
                                                                        {"Location " + (index + 1)}
                                                                    </span>
                                                            </Accordion.Title>
                                                            <Accordion.Content
                                                                active={activeIndex.indexOf(index) > -1}>
                                                                <div>
                                                                    <FormField
                                                                        placeholder={"Organization Location Name"}
                                                                        control={Input}
                                                                        label={<>
                                                                            <label> {i18n.become?.location_name || "Location Name"}<span
                                                                                className={"pull-right"}>&nbsp;
                                                                                *{i18n.become?.required_text}</span></label>
                                                                        </>
                                                                        }
                                                                        onChange={(e, target) => {
                                                                            let data = {...validation.values?.data}
                                                                            let locations = [...data.submission?.locations]
                                                                            let newLocation = locations.map((item, ind) => {
                                                                                let newItem = {...item}
                                                                                if (ind === index) {
                                                                                    newItem.location_name = e.target.value
                                                                                }
                                                                                return newItem
                                                                            })
                                                                            data = {
                                                                                ...validation.values.data,
                                                                                submission: {
                                                                                    ...data.submission,
                                                                                    locations: newLocation
                                                                                }
                                                                            }
                                                                            validation.setFieldValue("data", data)
                                                                        }}
                                                                        value={loc.location_name}

                                                                        error={isError("locations[" + index + "].location_name")}
                                                                    />

                                                                    <FormField
                                                                        error={isError("locations[" + index + "].location_address")}
                                                                    >
                                                                        <label> {i18n.become?.location_address || "Location Address"}<span
                                                                            className={"pull-right"}>&nbsp;
                                                                            *{i18n.become?.required_text}</span></label>
                                                                        <PlacesAutocomplete
                                                                           debounce={500}
                                                                            value={loc.location_address}
                                                                            onChange={handlePlaceChangeLanguage2(index)}
                                                                            onSelect={handlePlaceChangeLanguage2(index)}
                                                                        >
                                                                            {({
                                                                                  getInputProps,
                                                                                  suggestions,
                                                                                  getSuggestionItemProps,
                                                                                  loading
                                                                              }) => {
                                                                                return (
                                                                                    <div>
                                                                                        <Input
                                                                                            {...getInputProps({
                                                                                                placeholder: 'Organization Location Address',
                                                                                                className: 'location-search-input',
                                                                                            })}
                                                                                            loading={loading}/>
                                                                                        {suggestions.length > 0 &&
                                                                                            <div
                                                                                                className="autocomplete-dropdown-container">
                                                                                                {
                                                                                                    suggestions
                                                                                                        .map((suggestion, ind) => {
                                                                                                            const className = suggestion.active
                                                                                                                ? 'suggestion-item--active'
                                                                                                                : 'suggestion-item';
                                                                                                            // inline style for demonstration purpose
                                                                                                            const style = suggestion.active
                                                                                                                ? {
                                                                                                                    backgroundColor: '#fafafa',
                                                                                                                    cursor: 'pointer',
                                                                                                                    fontSize: '0.9em'
                                                                                                                }
                                                                                                                : {
                                                                                                                    backgroundColor: '#ffffff',
                                                                                                                    cursor: 'pointer',
                                                                                                                    fontSize: '0.9em'
                                                                                                                };
                                                                                                            return (
                                                                                                                <div
                                                                                                                    {...getSuggestionItemProps(suggestion, {
                                                                                                                        className,
                                                                                                                        style,
                                                                                                                    })}
                                                                                                                    key={ind}
                                                                                                                >
                                                                                                                    <span>{suggestion.description}</span>
                                                                                                                </div>
                                                                                                            );
                                                                                                        })
                                                                                                }
                                                                                            </div>}

                                                                                    </div>
                                                                                )
                                                                            }
                                                                            }
                                                                        </PlacesAutocomplete>
                                                                    </FormField>

                                                                    <FormField
                                                                        error={isError("locations[" + index + "].location_phone")}
                                                                    >
                                                                        <label>  {i18n.become?.office_phone_number || "Location Phone Number"}<span
                                                                            className={"pull-right"}>&nbsp;
                                                                            *{i18n.become?.required_text}</span></label>
                                                                        <InputMask
                                                                            inputMode="numeric"
                                                                            placeholder={"e.g. 555-555-5555"}
                                                                            aria-label={"Phone Number"}
                                                                            mask="(___) ___-____"
                                                                            replacement={{_: /\d/}}
                                                                            onChange={event => {
                                                                                let data = {...validation.values?.data}
                                                                                let locations = [...data.submission?.locations]
                                                                                let newLocation = locations.map((item, ind) => {
                                                                                    let newItem = {...item}
                                                                                    if (ind === index) {
                                                                                        newItem.location_phone = event.target.value
                                                                                    }
                                                                                    return newItem
                                                                                })
                                                                                data = {
                                                                                    ...validation.values.data,
                                                                                    submission: {
                                                                                        ...data.submission,
                                                                                        locations: newLocation
                                                                                    }
                                                                                }
                                                                                validation.setFieldValue("data", data)
                                                                            }}
                                                                            value={loc.location_phone || ""}
                                                                            error={isError("locations[" + index + "].location_phone")}
                                                                        />
                                                                        {/*<Cleave*/}
                                                                        {/*    aria-label={"Phone Number"}*/}
                                                                        {/*    name="phone"*/}
                                                                        {/*    placeholder="xxx xxx xxxx"*/}
                                                                        {/*    options={{*/}
                                                                        {/*        phone: true,*/}
                                                                        {/*        phoneRegionCode: "US",*/}
                                                                        {/*        numericOnly: true*/}
                                                                        {/*    }}*/}
                                                                        {/*    inputmode="numeric"*/}
                                                                        {/*    onChange={event => {*/}
                                                                        {/*        let data = {...validation.values?.data}*/}
                                                                        {/*        let locations = [...data.submission?.locations]*/}
                                                                        {/*        let newLocation = locations.map((item, ind) => {*/}
                                                                        {/*            let newItem = {...item}*/}
                                                                        {/*            if (ind === index) {*/}
                                                                        {/*                newItem.location_phone = event.target.rawValue*/}
                                                                        {/*            }*/}
                                                                        {/*            return newItem*/}
                                                                        {/*        })*/}
                                                                        {/*        data = {*/}
                                                                        {/*            ...validation.values.data,*/}
                                                                        {/*            submission: {*/}
                                                                        {/*                ...data.submission,*/}
                                                                        {/*                locations: newLocation*/}
                                                                        {/*            }*/}
                                                                        {/*        }*/}
                                                                        {/*        validation.setFieldValue("data", data)*/}
                                                                        {/*    }}*/}
                                                                        {/*    value={loc.location_phone || ""}*/}
                                                                        {/*    error={isError("locations[" + index + "].location_phone")}*/}
                                                                        {/*/>*/}
                                                                    </FormField>

                                                                    <FormField
                                                                        label={<>
                                                                            <label> {i18n.become?.service_offered || "Service Offered"}<span
                                                                                className={"pull-right"}>&nbsp;
                                                                                *{i18n.become?.required_text}</span></label>
                                                                            <span
                                                                                className={"text-muted"}> {i18n.become?.location_service_offered_sub || "Please select any items below that are related to the services your organization provides."}</span>
                                                                        </>
                                                                        }
                                                                        onChange={(e, target) => {
                                                                        }}
                                                                        error={isError("locations[" + index + "].services_offered")}
                                                                    />
                                                                    <Grid doubling columns={2}
                                                                          style={{marginLeft: 5}}>
                                                                        <Grid.Column style={{padding: 0}}>
                                                                            {validation.values?.data?.submission?.locations[index]?.services_offered?.filter(item => item.specified != true)?.map((offered, oindex) => {
                                                                                let firstHalf = validation.values?.data?.submission?.locations[index]?.services_offered?.length / 2
                                                                                return firstHalf >= oindex ? <React.Fragment key={oindex}>
                                                                                    <Checkbox
                                                                                        label={offered.name}
                                                                                        style={{
                                                                                            paddingBottom: 10,
                                                                                            paddingTop: 10
                                                                                        }}
                                                                                        checked={offered.selected}
                                                                                        onClick={(e, target) => {
                                                                                            let data = {...validation.values?.data}
                                                                                            let locations = [...data.submission?.locations]
                                                                                            let newLocation = locations.map((item, ind) => {
                                                                                                let newItem = {...item}
                                                                                                if (ind === index) {
                                                                                                    let newService = newItem.services_offered.map((soffered, sindex) => {
                                                                                                        let newsoffered = {...soffered}
                                                                                                        if (offered.name === newsoffered.name) {
                                                                                                            newsoffered.selected = target.checked
                                                                                                        }
                                                                                                        return newsoffered
                                                                                                    })
                                                                                                    newItem.services_offered = newService
                                                                                                }
                                                                                                return newItem
                                                                                            })
                                                                                            data = {
                                                                                                ...validation.values.data,
                                                                                                submission: {
                                                                                                    ...data.submission,
                                                                                                    locations: newLocation
                                                                                                }
                                                                                            }
                                                                                            validation.setFieldValue("data", data)
                                                                                        }}/><br/></React.Fragment> : null
                                                                            })}
                                                                        </Grid.Column>
                                                                        <Grid.Column style={{padding: 0}}>
                                                                            {validation.values?.data?.submission?.locations[index]?.services_offered?.filter(item => item.specified != true)?.map((offered, oindex) => {
                                                                                let secondHalf = validation.values?.data?.submission?.locations[index]?.services_offered?.length / 2

                                                                                return secondHalf <= oindex ? <React.Fragment key={oindex}>
                                                                                    <Checkbox
                                                                                        label={offered.name}
                                                                                        style={{
                                                                                            paddingBottom: 10,
                                                                                            paddingTop: 10
                                                                                        }}
                                                                                        checked={offered.selected}
                                                                                        onClick={(e, target) => {
                                                                                            let data = {...validation.values?.data}
                                                                                            let locations = [...data.submission?.locations]
                                                                                            let newLocation = locations.map((item, ind) => {
                                                                                                let newItem = {...item}
                                                                                                if (ind === index) {
                                                                                                    let newService = newItem.services_offered.map((soffered, sindex) => {
                                                                                                        let newsoffered = {...soffered}
                                                                                                        if (offered.name === newsoffered.name) {
                                                                                                            newsoffered.selected = target.checked
                                                                                                        }
                                                                                                        if (newsoffered.name === "Other") {
                                                                                                            setTimeout(() => {
                                                                                                                if (newsoffered.selected) {
                                                                                                                    newsoffered.specify = ""
                                                                                                                }
                                                                                                            }, 1000)
                                                                                                        }
                                                                                                        return newsoffered
                                                                                                    })

                                                                                                    let found = newService.find(accepted => {
                                                                                                        let others = accepted.name === "Other" && !accepted.selected
                                                                                                        return others
                                                                                                    })
                                                                                                    if (found) {
                                                                                                        newService = newService.filter(item => !item.specified)
                                                                                                    }
                                                                                                    newItem.services_offered = newService
                                                                                                }
                                                                                                return newItem
                                                                                            })
                                                                                            data = {
                                                                                                ...validation.values.data,
                                                                                                submission: {
                                                                                                    ...data.submission,
                                                                                                    locations: newLocation
                                                                                                }
                                                                                            }
                                                                                            validation.setFieldValue("data", data)
                                                                                        }}/>
                                                                                    {offered.name === "Other" && offered.selected &&
                                                                                        <FormField
                                                                                            style={{width: "90%"}}
                                                                                            control={Input}
                                                                                            onChange={(e, target) => {
                                                                                                let data = {...validation.values?.data}
                                                                                                let locations = [...data.submission?.locations]
                                                                                                let newLocation = locations.map((item, ind) => {
                                                                                                    let newItem = {...item}
                                                                                                    if (ind === index) {
                                                                                                        let newService = newItem.services_offered.map((soffered, sindex) => {
                                                                                                            let newsoffered = {...soffered}
                                                                                                            if (offered.name === newsoffered.name) {
                                                                                                                newsoffered.specify = e.target.value
                                                                                                            }
                                                                                                            return newsoffered
                                                                                                        })
                                                                                                        newItem.services_offered = newService
                                                                                                    }
                                                                                                    return newItem
                                                                                                })
                                                                                                data = {
                                                                                                    ...validation.values.data,
                                                                                                    submission: {
                                                                                                        ...data.submission,
                                                                                                        locations: newLocation
                                                                                                    }
                                                                                                }
                                                                                                validation.setFieldValue("data", data)
                                                                                            }}
                                                                                            placeholder={"Please specify"}
                                                                                            value={offered.specify}
                                                                                            error={offered.specify === ""}

                                                                                        />
                                                                                    }
                                                                                    <br/></React.Fragment> : null
                                                                            })}
                                                                        </Grid.Column>
                                                                    </Grid>
                                                                    <br/>
                                                                    <FormField
                                                                        rows={10}
                                                                        control={TextArea}
                                                                        placeholder={i18n.become?.description_of_service || "Description of Service"}
                                                                        label={<>
                                                                            <label> {i18n.become?.description_of_service || "Description of Service"}<span
                                                                                className={"pull-right"}>&nbsp;
                                                                                *{i18n.become?.required_text}</span></label>
                                                                            <span
                                                                                className={"text-muted"}> {i18n.become?.description_service_sub || "Please list the relevant services your organization provides. This description will be shown on the list of resources to patines. 500 character limit."}</span>
                                                                        </>
                                                                        }
                                                                        onChange={(e, target) => {
                                                                            let data = {...validation.values?.data}
                                                                            let locations = [...data.submission?.locations]
                                                                            let newLocation = locations.map((item, ind) => {
                                                                                let newItem = {...item}
                                                                                if (ind === index) {
                                                                                    newItem.services_description = e.target.value.substring(0, 500)
                                                                                }
                                                                                return newItem
                                                                            })
                                                                            data = {
                                                                                ...validation.values.data,
                                                                                submission: {
                                                                                    ...data.submission,
                                                                                    locations: newLocation
                                                                                }
                                                                            }
                                                                            validation.setFieldValue("data", data)
                                                                        }}
                                                                        value={loc.services_description}
                                                                        error={isError("locations[" + index + "].services_description")}
                                                                    />
                                                                    <div style={{
                                                                        color: "lightgray",
                                                                        textAlign: "right",
                                                                        marginTop: -50,
                                                                        marginRight: 15
                                                                    }}>{loc.services_description?.length} / 500
                                                                    </div>
                                                                    <br/>
                                                                    <FormField
                                                                        rows={10}
                                                                        control={TextArea}
                                                                        placeholder={i18n.become?.service_hours || "Service Hours"}
                                                                        label={<>
                                                                            <label> {i18n.become?.service_hours || "Service Hours"}<span
                                                                                className={"pull-right"}>&nbsp;
                                                                                *{i18n.become?.required_text}</span></label>
                                                                            <span
                                                                                className={"text-muted"}> {i18n.become?.service_hours_sub || "Please indicate the days and times your services are available to the public. Include specific hours for each day, and note any variations, such as weekend or holiday schedules. This helps ensure accurate and up-to-date information for individuals seeking support."}</span>
                                                                        </>
                                                                        }
                                                                        onChange={(e, target) => {
                                                                            let data = {...validation.values?.data}
                                                                            let locations = [...data.submission?.locations]
                                                                            let newLocation = locations.map((item, ind) => {
                                                                                let newItem = {...item}
                                                                                if (ind === index) {
                                                                                    newItem.services_hours = e.target.value.substring(0, 250)
                                                                                }
                                                                                return newItem
                                                                            })
                                                                            data = {
                                                                                ...validation.values.data,
                                                                                submission: {
                                                                                    ...data.submission,
                                                                                    locations: newLocation
                                                                                }
                                                                            }
                                                                            validation.setFieldValue("data", data)
                                                                        }}
                                                                        value={loc.services_hours}
                                                                        error={isError("locations[" + index + "].services_hours")}
                                                                    />
                                                                    <div style={{
                                                                        color: "lightgray",
                                                                        textAlign: "right",
                                                                        marginTop: -50,
                                                                        marginRight: 15
                                                                    }}>{loc.services_hours?.length} / 250
                                                                    </div>
                                                                    <br/>
                                                                </div>
                                                            </Accordion.Content>
                                                        </div>
                                                    })
                                                }
                                            </Accordion>
                                        </div>
                                        <h5 className={"text_header"}>
                                            <div className={"numbered_header"}>3
                                            </div>
                                            {i18n.become?.insurance_information || "Insurance Information"}
                                        </h5>
                                        <div>
                                            <FormField
                                                label={
                                                    <label> {i18n.become?.does_your || "Does your organization accept insurance?"}<span
                                                        className={"pull-right"}>
                                                &nbsp;
                                                        *{i18n.become?.required_text}</span></label>
                                                }

                                            />
                                            <Checkbox
                                                label={i18n.become?.yes_text || "Yes"}
                                                style={{paddingBottom: 10, paddingTop: 10}}
                                                checked={validation.values?.data?.submission?.insurance?.iniitial_accept_insurance}
                                                onClick={(e, target) => {
                                                    let data = {...validation.values?.data}
                                                    data = {
                                                        ...validation.values.data,
                                                        submission: {
                                                            ...data.submission,
                                                            insurance: {
                                                                ...data.submission.insurance,
                                                                accept_insurance: true,
                                                                iniitial_accept_insurance: true
                                                            }
                                                        }
                                                    }
                                                    validation.setFieldValue("data", data)
                                                }}/>
                                            <br/>
                                            <Checkbox
                                                label={i18n.become?.no_text || "No"}
                                                style={{paddingBottom: 10, paddingTop: 10}}
                                                checked={validation.values?.data?.submission?.insurance?.iniitial_accept_insurance === false}
                                                onClick={(e, target) => {
                                                    let data = {...validation.values?.data}
                                                    data = {
                                                        ...validation.values.data,
                                                        submission: {
                                                            ...data.submission,
                                                            insurance: {
                                                                ...data.submission.insurance,
                                                                accept_insurance: false,
                                                                iniitial_accept_insurance: false
                                                            }
                                                        }
                                                    }
                                                    validation.setFieldValue("data", data)
                                                }}/>
                                            <FormField
                                                error={isError("insurance.insurances_accepted")}
                                                label={
                                                    <>
                                                        <label> {i18n.become?.insurance_accepted || "Insurance Accepted"}<span
                                                            className={"pull-right"}>
                                                &nbsp;
                                                            *{i18n.become?.required_text}</span></label>
                                                        <span
                                                            className={"text-muted"}> {i18n.become?.insurance_accepted_sub || "If you accept insurance, please check all insurances your organization accepts."}</span>
                                                    </>
                                                }
                                            />
                                            <Grid doubling columns={2} style={{marginLeft: 5}}>
                                                <Grid.Column style={{padding: 0}}>
                                                    {validation.values?.data?.submission?.insurance?.insurances_accepted?.filter(item => item.specified != true)?.map((accepted, order) => {
                                                        let firstHalf = validation.values?.data?.submission?.insurance?.insurances_accepted?.length / 2
                                                        return firstHalf > order ?
                                                            <React.Fragment key={order}><Checkbox
                                                                label={accepted.name}
                                                                style={{paddingBottom: 10, paddingTop: 10}}
                                                                checked={accepted.selected}
                                                                onClick={(e, target) => {
                                                                    let data = {...validation.values?.data}
                                                                    let insurances_accepted = validation.values?.data?.submission?.insurance?.insurances_accepted?.map(item => {
                                                                        let newItem = {...item}
                                                                        if (newItem.name === accepted.name) {
                                                                            newItem.selected = target.checked
                                                                        }

                                                                        return newItem
                                                                    })
                                                                    data = {
                                                                        ...validation.values.data,
                                                                        submission: {
                                                                            ...data.submission,
                                                                            insurance: {
                                                                                ...data.submission.insurance,
                                                                                insurances_accepted
                                                                            }
                                                                        }
                                                                    }
                                                                    validation.setFieldValue("data", data)
                                                                }}/>

                                                                <br/> </React.Fragment> : null
                                                    })}
                                                </Grid.Column>
                                                <Grid.Column style={{padding: 0}}>
                                                    {validation.values?.data?.submission?.insurance?.insurances_accepted?.filter(item => item.specified != true)?.map((accepted, order) => {
                                                        let secondHalf = validation.values?.data?.submission?.insurance?.insurances_accepted?.length / 2
                                                        return secondHalf <= order ?
                                                            <React.Fragment  key={order}><Checkbox
                                                                label={accepted.name}
                                                                style={{paddingBottom: 10, paddingTop: 10}}
                                                                checked={accepted.selected}
                                                                onClick={(e, target) => {
                                                                    let data = {...validation.values?.data}
                                                                    let insurances_accepted = validation.values?.data?.submission?.insurance?.insurances_accepted?.map(item => {
                                                                        let newItem = {...item}
                                                                        if (newItem.name === accepted.name) {
                                                                            newItem.selected = target.checked
                                                                        }
                                                                        if (newItem.name === "Other") {
                                                                            setTimeout(() => {
                                                                                if (newItem.selected) {
                                                                                    newItem.specify = ""
                                                                                }
                                                                            }, 1000)
                                                                        }
                                                                        return newItem
                                                                    })
                                                                    let found = insurances_accepted.find(accepted => {
                                                                        let others = accepted.name === "Other" && !accepted.selected
                                                                        return others
                                                                    })
                                                                    if (found) {
                                                                        insurances_accepted = insurances_accepted.filter(item => !item.specified)
                                                                    }
                                                                    data = {
                                                                        ...validation.values.data,
                                                                        submission: {
                                                                            ...data.submission,
                                                                            insurance: {
                                                                                ...data.submission.insurance,
                                                                                insurances_accepted
                                                                            }
                                                                        }
                                                                    }
                                                                    validation.setFieldValue("data", data)
                                                                }}/>
                                                                {accepted.name === "Other" && accepted.selected &&
                                                                    <FormField
                                                                        style={{width: "90%"}}
                                                                        control={Input}
                                                                        onChange={(e, target) => {
                                                                            let data = {...validation.values?.data}
                                                                            let insurances_accepted = validation.values?.data?.submission?.insurance?.insurances_accepted?.map(item => {
                                                                                let newItem = {...item}
                                                                                if (newItem.name === accepted.name) {
                                                                                    newItem.specify = e.target.value
                                                                                }
                                                                                return newItem
                                                                            })
                                                                            data = {
                                                                                ...validation.values.data,
                                                                                submission: {
                                                                                    ...data.submission,
                                                                                    insurance: {
                                                                                        ...data.submission.insurance,
                                                                                        insurances_accepted
                                                                                    }
                                                                                }
                                                                            }
                                                                            validation.setFieldValue("data", data)
                                                                        }}
                                                                        placeholder={"Please specify"}
                                                                        value={accepted.specify}
                                                                        error={accepted.specify === "" && (validation.values?.data?.submission?.insurance?.accept_insurance || validation.values?.data?.submission?.insurance?.iniitial_accept_insurance)}
                                                                    />
                                                                }<br/> </React.Fragment> : null
                                                    })}
                                                </Grid.Column>
                                            </Grid>
                                        </div>
                                        <h5 className={"text_header"}>
                                            <div className={"numbered_header"}>4
                                            </div>
                                            {i18n.become?.additional_information}
                                        </h5>
                                        <div>
                                            <span
                                                className={"text-muted"}> {i18n.become?.additional_information_sub}</span>
                                            <br/>
                                            <br/>
                                            <FormField
                                                placeholder={"Additional Information"}
                                                rows={10}
                                                control={TextArea}
                                                name="optional_personalized_message"
                                                onChange={(e, target) => {
                                                    let data = {...validation.values?.data}
                                                    data = {
                                                        ...validation.values.data,
                                                        submission: {
                                                            ...data.submission,
                                                            additional_information: e.target.value
                                                        }
                                                    }
                                                    validation.setFieldValue("data", data)
                                                }}
                                                value={validation.values?.data?.submission?.additional_information || ""}
                                            />
                                        </div>
                                    </div>
                                }
                                <p style={{textAlign: "center", color: "blue"}}>
                                    {i18n.footer_text}
                                </p>

                                <div style={{textAlign: 'center'}}>
                                    {done ?
                                        <Button
                                            size='huge'
                                            color={'blue'}
                                            type="button"
                                            style={{paddingLeft: 70, paddingRight: 70, backgroundColor: "blue"}}
                                            onClick={handleStart}
                                        >
                                            Submit Another Resource
                                        </Button>
                                        :
                                        <Button
                                            size='huge'
                                            disabled={!validation.isValid ? loading : false}
                                            color={'blue'}
                                            aria-label={'submit'}
                                            type="submit"
                                            style={{paddingLeft: 70, paddingRight: 70, backgroundColor: "blue"}}
                                        >
                                            {i18n.become?.submit_button_text}
                                        </Button>
                                    }


                                </div>
                            </Form>
                        </Container>
                    </Container>

                </Sidebar.Pusher>
            </Sidebar.Pushable>
        </React.Fragment>
    );
};

export default withRouter(ClinicianForm);
